import { render } from "./Home.vue?vue&type=template&id=3ba7568e"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=3ba7568e&lang=css"

import exportComponent from "F:\\PROJECTS\\2022\\delish\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__